import { OrderParams } from "pages/order/OrderPage";
import { useParams } from "react-router-dom";
import { ChecklistParams } from "pages/checklist/ChecklistPage";
import Crumb from "features/breadcrumbs/Crumb";
import { OrderRowPageParams } from "./OrderRowPage";

const OrderRowCrumb: React.FC = () => {
  const { orderId, checklistId, rowId } = useParams<
    OrderParams & ChecklistParams & OrderRowPageParams
  >();

  return (
    <Crumb to={`/orders/view/${orderId}/checklist/${checklistId}/products/${rowId}`}>
      Rad {rowId}
    </Crumb>
  );
};

export default OrderRowCrumb;
